import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Albuquerque, NM?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through a post office or acceptance clerk in Albuquerque can take 2–6 months, especially during busy travel seasons. For military families at Kirtland AFB, Sandia Labs researchers, and cross-border family travelers, that timeline is simply not viable.",
  },
  {
    q: "Can Kirtland AFB military families expedite a passport quickly?",
    a: "Absolutely. Military families are one of our most common client types in Albuquerque. PCS orders often arrive with 30 days or less to report, and dependent passports must be current for overseas assignments. We regularly process expedited renewals, new applications, and child passports for Air Force, Space Force, and contractor families on compressed timelines. Contact us as soon as orders arrive — do not wait until the week before your flight.",
  },
  {
    q: "What if my passport expires before a family reunion in Mexico?",
    a: "This happens more often than you would think, especially for families planning quinceañeras, weddings, or holiday reunions in Chihuahua, Juárez, or northern Mexico. Your passport must be valid for the duration of your stay. If your expiration is cutting it close, we strongly recommend expedited processing. Standard mail-in renewal through an Albuquerque post office typically takes 2–6 months — far too long for an upcoming family event.",
  },
  {
    q: "Can UNM students get a passport fast for study abroad in Spain or Latin America?",
    a: "Yes. UNM study-abroad program deadlines often fall in October and March, but many students do not think about their passport until after acceptance — leaving as little as 4–6 weeks. First-time applicants require an in-person acceptance clerk visit. We guide UNM and CNM students through the exact location, forms, and timeline so they do not miss their program orientation in Madrid, Buenos Aires, or Mexico City.",
  },
  {
    q: "How quickly can travelers in Rio Rancho or Los Lunas receive an expedited passport?",
    a: "Rio Rancho and Los Lunas travelers have the same access to our expedited services as Albuquerque residents. Since we operate remotely, your physical location in Central New Mexico does not affect processing speed. Ship your documents overnight from Sandoval or Valencia County, and we handle the rest. Most clients in the Albuquerque metro area receive their passports within 2–9 business days.",
  },
  {
    q: "Can Sandia National Labs professionals expedite a passport for an international conference?",
    a: "Yes — Sandia Labs researchers, Intel professionals, and cleared personnel are well within our service area. Whether you are presenting at a conference in Germany, attending a collaborative meeting in Japan, or visiting a manufacturing facility in Asia, we make the renewal or new application process straightforward. You do not need to drive to El Paso for a passport agency appointment. Start online, ship your documents, and we handle the expedited submission.",
  },
  {
    q: "Do I need to visit an office to use Fast Passport Center?",
    a: "No — most Albuquerque travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Albuquerque, but that is the point: you do not need one. Start your order online, follow the checklist, and ship your documents overnight from anywhere in the Albuquerque metro area or Central New Mexico.",
  },
  {
    q: "What documents do I need for an expedited passport?",
    a: "Most applicants need: proof of U.S. citizenship (current or expired U.S. passport, birth certificate, or naturalization certificate), a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order, so you know exactly what is required for your specific situation.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing through reserved courier submission availability.",
  },
];

export default function AlbuquerqueFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Albuquerque and Central New Mexico travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i
                    className={`text-white text-sm transition-transform duration-200 ${
                      openIndex === i ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}